import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { Box, Button, Typography } from '@mui/material';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import { COMMON_DATE_FORMAT } from 'constants/date';

import { closeDialogAction } from 'store/global/actions';

import { DisclosureDeliveryTestIds } from '../../DisclosureDelivery.testIds';

const CancelSendingBundlePopup = ({ date, onConfirm }) => {
  const dispatch = useDispatch();

  const onSubmit = useCallback(async () => {
    await onConfirm();

    dispatch(closeDialogAction());
  }, [dispatch, onConfirm]);

  return (
    <Box className="flex flex-col items-stretch">
      <Typography className="max-w-320" variant="regular14">
        Are you sure you want to cancel the bundle scheduled for{' '}
        {date ? `${dayjs(date).format(COMMON_DATE_FORMAT)}` : 'N/A'}?
      </Typography>
      <Box className="pt-16 self-end">
        <Button
          data-testid={DisclosureDeliveryTestIds.CANCEL_BUNDLE_CONFIRM_BUTTON}
          variant="contained"
          onClick={onSubmit}
        >
          Yes
        </Button>
      </Box>
    </Box>
  );
};

CancelSendingBundlePopup.propTypes = {
  date: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default CancelSendingBundlePopup;
